import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { EditEmployeeAPI, GetEmployeByEmail, GetEmployeeRole, GetEmployeeStatus } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";
import { toast } from 'react-toastify';

function EditEmployee() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState(false);
  const { employeeEmailId } = useParams();
  const [employeeData, setEmployeeData] = useState({});
  const [rolesData, setRolesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [fetchEmployeeData, setFetchEmplpoyeeData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  useEffect(() => {
    (
      async () => {
        setLoading(true);
        try {
          const response = await GetEmployeByEmail(employeeEmailId, localStorage.getItem('accessToken'));
          const statusResponse = await GetEmployeeStatus(localStorage.getItem('accessToken'));
          const rolesResponse = await GetEmployeeRole(localStorage.getItem('accessToken'));
          setLoading(true);
          setStatusData(statusResponse.data.statuses);
          setRolesData(rolesResponse.data.roles);
          setEmployeeData(response.data);
          response.data.map((item)=>{
            setEditedEmployeeData(item);
          })
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    )();
  }, [fetchEmployeeData]);

  const handleFirstNameChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.firstname = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleLastNameChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.lastname = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleEmployeeCodeChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.empcode = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handlePhoneNumberChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.employeephone = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleDesignationChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.designation = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleRoleChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.roleid = e.target.value;
    setEditedEmployeeData(temp);
  };

  // const getStatus = (statusid) => {
  //   return statusData.
  // };

  const handleStatusChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.statusid = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleDiscardClick = () => {
    const temp = { ...employeeData };
    setEditedEmployeeData(temp);
    navigate("/employee");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    try {
      if (editedEmployeeData.firstname === "") {
        toast.error("First Name is required");
        return;
      }
      if (editedEmployeeData.lastname === "") {
        toast.error("Last Name is required");
        return;
      }
      if (editedEmployeeData.employeephone === "") {
        toast.error("Contact Number is required");
        return;
      }
      if (!editedEmployeeData.employeephone.match(/^\d{10}$/)) {
        toast.error("Contact Number is required");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      setEditLoading(true);
      const {
        firstname,
        lastname,
        empcode,
        employeephone,
        designation,
        emailid,
        statusid,
        roleid,
      } = editedEmployeeData;
      response = await EditEmployeeAPI(
        {
          firstname,
          lastname,
          empcode,
          employeephone,
          designation,
          emailid,
          statusid,
          roleid,
        },
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        navigate("/employee");
        setEditLoading(false);
        toast.success("Employee Updated Successfully");

      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Employee</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/employee" className="btn btn-primary px-4">View All</NavLink>
          </div>
        </div>
        {
          loading ?
            <div className="d-flex align-items-center justify-content-center">
              <RiLoaderFill size={40} className="text-success spin-animation text-center" />
            </div> :
            <div role="tabpanel" className="personal-info tab-pane active" id="pi">
              {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleFirstNameChange} value={editedEmployeeData?.firstname || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Firstname</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleLastNameChange} value={editedEmployeeData?.lastname || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Lastname</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleEmployeeCodeChange} value={editedEmployeeData?.empcode || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Employee Code</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handlePhoneNumberChange} value={editedEmployeeData?.employeephone || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Phone Number</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleDesignationChange} value={editedEmployeeData?.designation || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Designation</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={editedEmployeeData?.emailid || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Email ID</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={formatUTCDate(editedEmployeeData?.createddate) || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Created Date</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={formatUTCDate(editedEmployeeData?.modifieddate) || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Modified Date</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={editedEmployeeData?.createdby || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Created By</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={editedEmployeeData?.modifiedby || ""} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Modified By</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <select className="form-select" onChange={handleStatusChange} value={editedEmployeeData?.statusid || ""} >
                      {
                        statusData?.map((item, index) => (
                          <option value={item.statusid} key={index}>
                            {item.status}
                          </option>
                        ))
                      }
                    </select>
                    <label htmlFor="floatingInput">Status</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <select className="form-select" onChange={handleRoleChange} value={editedEmployeeData?.roleid || ""} >
                      {
                        rolesData?.map((item, index) => (
                          <option value={item.roleid} key={index}>
                            {item.role}
                          </option>
                        ))
                      }
                    </select>
                    <label htmlFor="floatingInput">Role</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-12 d-flex"
                  style={{ height: "40px", width: "120px" }}
                >
                  <button
                    type="submit"
                    onClick={handleDiscardClick}
                    disabled={editLoading}
                    style={{ height: "100%", width: "100%" }}
                    className="btn btn-danger save-btn text-uppercase"
                  >
                    Discard
                  </button>{" "}
                  &nbsp;
                  {editLoading ? (
                    <div
                      className="btn btn-primary loader-active save-btn"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <RiLoaderFill
                        size={20}
                        className="spin-animation"
                        color="white"
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      disabled={editLoading}
                      onClick={handleSubmitClick}
                      className="btn btn-primary save-btn text-uppercase"
                      style={{ height: "100%", width: "100%" }}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
        }
        <hr />
      </div >
    </div >
  );
}
export default EditEmployee;